import { Flex, Text } from "@chakra-ui/react";
import CheckmarkIllustration from "assets/illustrations/success/Checkmark.svg?react";
import { Modal, ModalButtons } from "components/modal/Modal";

export const NewVersionModal = () => (
  <Modal
    title={
      <Flex width="100%" justifyContent="center">
        <CheckmarkIllustration width={200} height={200} />
      </Flex>
    }
    hasCloseButton={false}
    onClose={() => {}}
    isOpen={true}
    data-cy="new-version-modal"
    width="400px"
  >
    <Flex direction="column" gap="6">
      <Text textStyle="h4">New console version available</Text>
      <Text>
        Refresh the page to get the latest updates to Tiger Cloud. This won’t
        affect your database or services — it just brings UI improvements and
        bug fixes.
      </Text>
    </Flex>
    <ModalButtons
      primaryCTA={{
        text: "Refresh",
        onClick: () => {
          window.location.reload();
        },
      }}
      secondaryCTA={undefined}
    />
  </Modal>
);
